import Avatar from '@components/dataDisplay/Avatar';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import { IPhotoCard } from '@typings/photocard/photocard.interface';
import React from 'react';
import styled from 'styled-components';

export const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--subTextColor);

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
  }
`;

type Props = {
  photocardID: string;
};
function PhotocardMiniTag({ photocardID }: Props) {
  const { data } = useDocument<IPhotoCard>(
    `${CollectionPath.PHOTOCARD}/${photocardID}`,
    { listen: false },
  );

  return (
    <>
      <Tag>
        <Avatar size={20} photoURL={data?.thumbnail} />
        <b>{data?.title}</b>
      </Tag>
    </>
  );
}

export default PhotocardMiniTag;
